import dot from '@/components/services/report-manager/commons/timeline/dot'

const baseClass = 'timeline-mini'

function renderTrack(h, isLast) {
  if (isLast) {
    return null
  }

  return h(
    'div',
    {
      class: `${baseClass}__track`
    }
  )
}

function renderDot(h, point) {
  return h(
    dot,
    {
      props: {
        icon: this.getPointIcon(point),
        color: this.getPointColor(point),
        tooltip: this.getTooltip(point)
      }
    }
  )
}
function renderPoint(h, point, index) {
  const isLast = index === this.timelinePoints.length - 1

  return h(
    'div',
    {
      class: `${baseClass}__point`
    },
    [
      renderDot.call(this, h, point),
      renderTrack.call(this, h, isLast)
    ]
  )
}
function renderPoints(h) {
  return h(
    'div',
    {
      class: `${baseClass}__points`
    },
    [
      this.timelinePoints.map((point, index) => {
        return renderPoint.call(this, h, point, index)
      })
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: baseClass
    },
    [ renderPoints.call(this, h) ]
  )
}
